module.exports = __webpack_public_path__ + "media/images/business/sd-timeline-7078f6fbb82efdb3419fcba8e4676c09.svg";